
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWireThreeway as ObiWireThreewayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wire-threeway.js';
 
 
 

 
 export const ObiWireThreeway = createComponent({
   react: React,
   tagName: 'obi-wire-threeway',
   elementClass: ObiWireThreewayElement,
   events: {
     
   }
  });
 
 